import { createLocalStorageStore } from '#/zustand-stores/utils/createLocalStorageStore';

const { getValue, setValue, useValue } = createLocalStorageStore<number>({
  key: 'idealist:unsigned-page-visit-count',
  getInitializationValue: (localStorageData) => {
    return localStorageData ?? 0;
  },
});

// Actions

export function incrementPageVisitCount() {
  setValue((getValue() ?? 0) + 1);
}

export function resetPageVisitCount() {
  setValue(0);
}

// Hooks

export function usePageVisitCount() {
  return useValue()!; // The value has a fallback via getInitializationValue
}
